/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocalisationDto } from '../../models/localisation-dto';

export interface PatchLocalisation$Params {
  idLoc: string;
  body: LocalisationDto;
}

export function patchLocalisation(
  http: HttpClient,
  rootUrl: string,
  params: PatchLocalisation$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<{}>> {
  const rb = new RequestBuilder(rootUrl, patchLocalisation.PATH, 'patch');
  if (params) {
    rb.path('idLoc', params.idLoc, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'blob', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{}>;
    })
  );
}

patchLocalisation.PATH = '/v1/localisations/{idLoc}';
